import AppForm from '@/components/AppForm';
import AppPageTitle from '@/components/AppPageTitle';
import PATH from '@/config/paths/PATH';
import useFormSubmit from '@/hooks/useFormSubmit';
import useWheel from '@/redux/hooks/useWheel';
import { updateWheel } from '@/services/wheel.service';
import { useMutation } from '@tanstack/react-query';
import { Col, Form, Input, Row, Space } from 'antd';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

function WheelUpdate() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const wheelMutation = useMutation({
    mutationFn: updateWheel,
  });
  const { tile, clearWheel } = useWheel();
  const initialValues = useMemo(() => {
    if (!tile) return {};
    return {
      ...tile,
      // showing: tile.showing === 1 ? true : false,
    };
  }, [tile]);

  const handleOnSubmit = useFormSubmit(
    wheelMutation,
    (values) => ({
      ...values,
      id: tile?.id,
      // showing: values.showing ? 1 : 2,
    }),
    {
      onOk: async () => {
        await navigate(PATH.WHEEL.ROOT, {
          replace: true,
        });
        clearWheel();
      },
    }
  );

  return (
    <Space direction="vertical" className="w-full">
      <AppPageTitle title="Update Tile" />
      <AppForm
        form={form}
        initialValues={initialValues}
        onSubmit={handleOnSubmit}
        targetPath={PATH.WHEEL.ROOT}
        buttonProps={{
          loading: wheelMutation.isPending,
          disabled: wheelMutation.isPending,
        }}
        disabled={wheelMutation.isPending}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="Tile Name"
              name="name"
              rules={[{ required: true, message: 'Please enter tile name' }]}
            >
              <Input placeholder="Enter tile name" />
            </Form.Item>
            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true, message: 'Please enter description' }]}
            >
              <Input placeholder="Enter description" />
            </Form.Item>
            {/* <Form.Item name="showing" valuePropName="checked" label="Showing">
              <Switch title="Showing" />
            </Form.Item> */}
          </Col>
        </Row>
      </AppForm>
    </Space>
  );
}

export default WheelUpdate;
